<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">NARUČENE KOLIČINE PO GRUPI</h2>

  <div class="content-block if-filters">
    <div>
      <label>Datum od</label>
      <dx-date-box
        [(value)]="datumOd"
        [(max)]="datumDo"
        pickerType="calendar"
        displayFormat='dd.MM.yyyy.'
        width="200"
        (onValueChanged)="promjenaDatumOd($event)"
      >
      </dx-date-box>
    </div>
    <div>
      <label>Datum do</label>
      <dx-date-box
        [(value)]="datumDo"
        [(min)]="datumOd"
        pickerType="calendar"
        displayFormat='dd.MM.yyyy.'
        width="200"
        (onValueChanged)="promjenaDatumDo($event)"
      >
      </dx-date-box>
    </div>
    <div *ngIf="grupe.length">
      <span>Grupa</span>
      <dx-select-box
        [items]="grupe"
        [value]="grupe[0].idpartnergrupa"
        valueExpr="idpartnergrupa"
        displayExpr="pg_naziv"
        [width]="300"
        (onValueChanged)="promjenaGrupe($event)"
      >
      </dx-select-box>
    </div>
  </div>

  <div class="customTable nadzornaPloca m-40 toolbar45">
    <div id="data-grid-demo">
      <dx-data-grid
        id="gridContainer"
        [dataSource]="naruceneKolicine"
        [wordWrapEnabled]="true"
        keyExpr="ds_id"
        [showBorders]="false"
        [showColumnLines]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'">
          <div class="naslov">
            <h2 class="mb-0">Naručene količine</h2>
          </div>
        </div>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>
        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>
        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>
        <dxo-grouping [autoExpandAll]="false"></dxo-grouping>

        <dxi-column
          dataField="ar_sifra"
          caption="Šifra proizvoda"
          [width]="150"
        ></dxi-column>
        <dxi-column
          dataField="ar_naziv"
          caption="Proizvod"
          [minWidth]="300"
        ></dxi-column>
        <dxi-column
          dataField="naruceno"
          caption="Naručeno"
          [width]="200"
        ></dxi-column>
        <dxi-column
          dataField="brojkutija"
          caption="Kutija"
          [width]="100"
        ></dxi-column>
        <dxi-column
          dataField="brojpaleta"
          caption="Paleta"
          [width]="100"
        ></dxi-column>
        <dxi-column
          dataField="trenutnostanje"
          caption="Stanje"
          [width]="200"
        ></dxi-column>
        <dxi-column
          dataField="pa_naziv"
          caption="Poslovnica"
          [minWidth]="300"
        ></dxi-column>
        <dxi-column
          dataField="pg_naziv"
          caption="Grupa"
          [width]="200"
          [groupIndex]="0"
        ></dxi-column>

        <dxo-summary
          ><dxi-group-item
            column="ar_id"
            summaryType="count"
            displayFormat="Ukupno proizvoda: {0}"
          >
          </dxi-group-item>
          <dxi-group-item
            column="naruceno"
            summaryType="sum"
            [alignByColumn]="true"
            displayFormat="{0}"
          >
          </dxi-group-item>
          <dxi-group-item
            column="trenutnostanje"
            summaryType="sum"
            [alignByColumn]="true"
            displayFormat="{0}"
          >
          </dxi-group-item>
          <!-- <dxi-total-item
          column="naruceno"
          summaryType="sum"
          displayFormat="Ukupno: {0}"
          [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
        >
        </dxi-total-item> -->
        </dxo-summary>
      </dx-data-grid>
    </div>
  </div>
</div>
